import React from 'react';
import type { JobAd } from '../../../types';

type JobSummaryProps = {
    ad: JobAd;
    className?: string;
};

export function JobSummary(props: JobSummaryProps) {
    const { ad, className = '' } = props;

    if (!ad.job_title) {
        return null;
    }

    return (
        <div className={`${className} space-x-12 font-bold whitespace-nowrap`}>
            {ad.job_title && ad.heading !== ad.job_title && (
                <span>{ad.job_title}</span>
            )}
        </div>
    );
}
